import { render, staticRenderFns } from "./DivisionTabs.vue?vue&type=template&id=3f384b33"
import script from "./DivisionTabs.vue?vue&type=script&lang=js"
export * from "./DivisionTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports